export class LoginModel {
    username = '';
    password = '';
    token = '';
}



